import { render, staticRenderFns } from "./VideoModals.vue?vue&type=template&id=5804950f&scoped=true"
import script from "./VideoModals.vue?vue&type=script&lang=js"
export * from "./VideoModals.vue?vue&type=script&lang=js"
import style0 from "./VideoModals.vue?vue&type=style&index=0&id=5804950f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5804950f",
  null
  
)

export default component.exports